import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#f7dad9',
    borderRadius: '20px',
    display: 'inline-flex',
    left: '50%',
    position: 'absolute',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    zIndex: '-100'
  },
  icon: {
    margin: 'auto 1em auto 2em'
  },
  message: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1rem'
  }
}))

const LoginError = props => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <i class='fas fa-exclamation-circle fa-5x' />
      </div>
      <div className={classes.message}>
        <b>There was a problem loading the control center</b>
        <br />
        Please try again. You can contact our support team below.
        <a
          href='https://invintus-support.freshdesk.com/support/home'
          about='_blank'
        >
          https://invintus-support.freshdesk.com/support/home
        </a>
        <a href='mailto:support@invintus.com'>support@invintus.com</a>
        <br />1 (800) 496-1637
      </div>
    </div>
  )

}

export default LoginError
